import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      here: '日ごとの集計',
      ancestries: _ctx.ancestries
    }, null, 8, ["ancestries"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
      }, "日ごとの集計", 4)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "日付"),
              _createElementVNode("th", null, "前払い申請額（①）"),
              _createElementVNode("th", null, "システム利用料（②）"),
              _createElementVNode("th", null, "振込手数料（③）"),
              _createElementVNode("th", null, "振り込み金額(① - ② - ③)")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aggregations, (aggr) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: aggr.vForKey
              }, [
                _createElementVNode("td", null, _toDisplayString(aggr.dateString), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(aggr.amount.toLocaleString()), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(aggr.systemFeeTotal.toLocaleString()), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(aggr.transferFeeTotal.toLocaleString()), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(aggr.transferredAmount.toLocaleString()), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}